import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { logOut } from '../redux/features/user.features'

const LogOut = () => {
const dispatch = useDispatch()
useEffect(()=>{
    dispatch(logOut())
},[dispatch])
  return (
    <div>LogOuting please wait...</div>
  )
}

export default LogOut